var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.80723C0 15.2169 4.43769 19.6145 9.89666 19.6145C11.9271 19.6145 13.7872 19 15.3435 17.9518L20.9362 23.494C21.2766 23.8434 21.7508 24 22.2249 24C23.2584 24 24 23.2289 24 22.2289C24 21.747 23.8298 21.3012 23.5015 20.9639L17.9453 15.4458C19.1003 13.8675 19.7933 11.9157 19.7933 9.80723C19.7933 4.39759 15.3556 0 9.89666 0C4.43769 0 0 4.39759 0 9.80723ZM2.57751 9.80723C2.57751 5.80723 5.84802 2.55422 9.89666 2.55422C13.9331 2.55422 17.2158 5.80723 17.2158 9.80723C17.2158 13.8072 13.9331 17.0602 9.89666 17.0602C5.84802 17.0602 2.57751 13.8072 2.57751 9.80723ZM6.75988 10.747H13.0334C13.5562 10.747 13.9818 10.3253 13.9818 9.80723C13.9818 9.28916 13.5562 8.86747 13.0334 8.86747H6.75988C6.24924 8.86747 5.79939 9.28916 5.81155 9.80723C5.81155 10.3253 6.24924 10.747 6.75988 10.747Z",
    fill: "#D8E8EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.e4b2758cba7da775cbed0c7d5b990fa8.svg";
export { ForwardRef as ReactComponent };